// removed by extract-text-webpack-plugin
module.exports = {"btn-apex-primary":"_3wcRS2B6JGquZE_ElgGp8f","focus":"_1QeCFLOPBeE_Rq2w9QMRLz","active":"_35E6VL69PxhiqSUE4mqDCZ","disabled":"_1RPFwSOGZ4uCINfTyNqMYl","badge":"_2Dzt2qY3S574gY8OhrORXP","btn-apex-secondary":"_YTqsipLKMhKn_mJ9QaiH","btn-apex-secondary-no-hover":"z-WSZyYRxjlJP6_uIFRwF","btn-apex-negative":"_2kUgo3trXgW3GhEQoS4wXf","btn-apex-orange":"_2-lFNCPpRwIAbm8XbxQ9OX","container":"_3yj5N2sTxwcz3zBCmpSASt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TabbedDetailsPanel/styles.css
// module id = 3210
// module chunks = 0